/**
 * Provides JS functionality for tracking alert display.
 */
/* istanbul ignore file - No need to test Slick */
class DoctorSlider extends DrupalBehavior {
  onContent(context) {
    $('.doctor-slider--items', context).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }
}

DrupalBehavior.register('rush_theme.components', 'doctor_slider', DoctorSlider);
